"use client"

import styled from "@emotion/styled"
import { Box, Typography } from "@mui/material"

const StyledContainer = styled(Box)`
  width: 100%;
  height: 390px;
  ${(props) => props.theme.breakpoints.up("md")} {
    height: 515px;
  }

  border-radius: 8px;
  overflow: hidden;
`

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`

interface SpinCarWidgetProps {
  spinCarId: string
}

export default function SpinCarWidget({ spinCarId }: SpinCarWidgetProps) {
  const widgetUrl = `https://spins.spincar.com/eurodrive/${spinCarId}`

  return (
    <StyledContainer>
      <Typography variant="h3">גלריית תמונות הרכב</Typography>
      <StyledIframe
        src={widgetUrl}
        title="SpinCar 360° Vehicle View"
        allow="fullscreen"
        loading="lazy"
        width={"100%"}
      />
    </StyledContainer>
  )
}
